import UploadFileForm from "components/FileUpload/UploadFileForm"
import { DownloadTemplateFile, UploadAssets } from "api/assets.api"
import { alertErrorMessage } from "utils/alerts"
import { useNavigate } from "react-router-dom"
import { routePath } from "router/routePaths"
import { AssetForm } from "../AssetForm/AssetForm"
import FormHeader from "components/FormHeader"
import { Box } from "gls"
import { style } from "typestyle"
import { colours } from "styling/colours"
import { useUserRolePermissionStore } from "contexts/RootStore.context"
import useDevice from "hooks/useDevice"
import NoPermissionsPage from "views/NoPermissionsPage"
import WidthNotSupportedPage from "views/WidthNotSupportedPage"
import ScrollingContainer from "components/ScrollContainer/ScrollingContainer"


export const AssetManagement = () => {

  const navigate = useNavigate()
  const { isMobileDevice } = useDevice();
  const { canViewAssets } = useUserRolePermissionStore()

  const downloadTemplate = () => {
    DownloadTemplateFile()
      .catch(() => {
        alertErrorMessage('Error downloading file');
      })
  }

  const onUpload = (file: File) => {
    return UploadAssets(file)
      .then(() => navigate(routePath.assetList))
  }

  if (!canViewAssets) {
    return <NoPermissionsPage />
  }

  if (isMobileDevice) {
    return <WidthNotSupportedPage />;
  }

  return (
    <ScrollingContainer>
      <FormHeader text="UPLOAD ASSET" />
      <Box className={BoxStyle}>
        <UploadFileForm
          objectTitle="Assets"
          onDownloadTemplate={downloadTemplate}
          onUpload={onUpload}
        />
      </Box>
      <FormHeader text="ADD INDIVIDUAL ASSET" />
      <AssetForm />
    </ScrollingContainer>
  )
}

const BoxStyle = style({
  backgroundColor: colours.white,
  padding: "20px",
  marginBottom: "20px",
  overflowY: "scroll"
})